import React, { FC } from "react";
import "./NoGroupAssigned.scss";
import Logout from "../../assets/Logout.svg";
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";

const NoGroup: FC = () => {
  const { instance } = useMsal();
  const { t } = useTranslation();

  const handleLogout = () => {
    instance.logoutRedirect({
        postLogoutRedirectUri: "/",
    });
  };

  return (
    <div className="flex flex-col w-[315px] max-h-[542px] p-5 bg-white rounded-md">
      <h2 className="popup-title">No Group Assigned</h2>

      <div className="feedback mt-[15px]">
        <p className="message mb-[10px]">
          {
            "You currently do not have any group assigned to your account. Please contact the administrator for assistance."
          }
        </p>
      </div>
      <div className="logout mt-[15px]">
        <div className="logout-button-wrapper">
          <button
            className="button-primary button-border-gray button-text flex justify-center items-center"
            onClick={handleLogout}
          >
            <img src={Logout} className="inline pr-[5px] logout" />
            {"Logout"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoGroup;
